import { render, staticRenderFns } from "./ProductAssociationFields.vue?vue&type=template&id=490fc86a&"
import script from "./ProductAssociationFields.vue?vue&type=script&lang=js&"
export * from "./ProductAssociationFields.vue?vue&type=script&lang=js&"
import style0 from "./ProductAssociationFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports